import { render } from "./ViewsErrors403.vue?vue&type=template&id=5c8218d2"
import script from "./ViewsErrors403.vue?vue&type=script&lang=js"
export * from "./ViewsErrors403.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__